import studentChooseTeacher from './studentChooseTeacher';
import studentChooseTeacherResult from './studentChooseTeacherResult';
import teacherConfirm from './teacherConfirm';
import teacherChooseResult from './teacherChooseResult';
import studentChooseResult from './studentChooseResult';
import teacherChooseStudentResult from './teacherChooseStudentResult';
import studentConfirm from './studentConfirm';
import studentInfoInsert from './StudentInfoInsert';
import studentEnterprise from './studentEnterprise';
import teacherStudentAllot from './teacherStudentAllot';
import teacherChooseStudent from './teacherChooseStudent';
import salaryAnalysisByOrg from './salaryAnalysisByOrg';
import salaryAnalysisBySwot from './salaryAnalysisBySwot';
import teacherStudentAllot2 from './teacherStudentAllot2';
import industryAnalysis from './industryAnalysis';
import detailIndustryAnalysis from './detailIndustryAnalysis';
import enterpriseAnalysis from './enterpriseAnalysis';
import enterpriseInfo from './enterpriseInfo';

export default {
    studentChooseTeacher,
    studentChooseTeacherResult,
    teacherConfirm,
    teacherChooseResult,
    studentChooseResult,
    teacherChooseStudentResult,
    studentConfirm,
    studentInfoInsert,
    studentEnterprise,
    teacherStudentAllot,
    teacherChooseStudent,
    salaryAnalysisByOrg,
    salaryAnalysisBySwot,
    teacherStudentAllot2,
    industryAnalysis,
    detailIndustryAnalysis,
    enterpriseAnalysis,
    enterpriseInfo
}